__turbopack_context__.v({
  "blogNavBar": "IZI1Wq_blogNavBar",
  "buttonLabel": "IZI1Wq_buttonLabel",
  "rightNavGroup": "IZI1Wq_rightNavGroup",
});
